import ReactOnRails from 'react-on-rails';

import App from '../bundles/App/startup/App';

ReactOnRails.register({
  App,
});
